import { createMuiTheme } from '@material-ui/core';
import colours from 'styles/colours';
import apolloColours from 'styles/apolloColours';
import datePickerThemeOverrides from './styles/datePickerOverrides';

const sideBarWidth = 240;
const fontSize = '14px';
const boldFont = 'bold';

const defaultFontFamily =
  "apple-system, system-ui, 'Segoe UI', Arial, Helvetica, Roboto, sans-serif";

const defaultTheme = createMuiTheme({
  dimension: {
    sideBarWidth: sideBarWidth,
  },
  palette: {
    common: {
      ...colours,
    },
    xpl: {
      ...apolloColours,
    },
  },
  typography: {
    fontFamily: defaultFontFamily,
    h1: {
      fontSize: 38,
      fontWeight: boldFont,
    },
    h2: {
      fontSize: 32,
      fontWeight: boldFont,
    },
    h3: {
      fontSize: 26,
      fontWeight: boldFont,
    },
    h4: {
      fontSize: 20,
      fontWeight: boldFont,
    },
    h5: {
      fontSize: 16,
      fontWeight: boldFont,
    },
    h6: {
      fontSize: 12,
    },
    body1: {
      color: apolloColours.text.primary,
      fontSize: fontSize,
    },
    body2: {
      fontSize: fontSize,
    },
    subheading: {
      color: apolloColours.text.primary,
    },
  },
  //Try to move away from overrides and material-ui components use in general.
  overrides: {
    MuiTypography: {
      colorPrimary: {
        color: apolloColours.text.primary,
      },
    },
    MuiTableCell: {
      head: {
        fontWeight: boldFont,
        color: apolloColours.text.primary,
        fontSize: fontSize,
        borderBottomColor: apolloColours.stoke,
      },
    },
    MuiTableRow: {
      root: {
        '&$hover:hover': {
          backgroundColor: apolloColours.secondary.background,
        },
      },
      hover: {},
    },
    MuiTableSortLabel: {
      root: {
        '&:hover': {
          color: apolloColours.secondary.hover,
        },
        '&:focus': {
          color: apolloColours.secondary.hover,
        },
      },
      active: {
        color: apolloColours.secondary.hover,
      },
    },
    ...datePickerThemeOverrides,
  },
});

export { defaultFontFamily, defaultTheme };
